import * as React from 'react'
import i18n from 'i18n'
import { resolveInitialLanguage } from 'i18n/config'

// Last-resort EN texts: this screen renders when React crashed, possibly i18n itself.
const FALLBACK_MESSAGES = {
    title: 'Something went wrong',
    body: 'An unexpected error occurred. Try reloading the page.',
    hint: 'If the problem persists, disable browser extensions (translators, spell checkers) and try again.',
    reload: 'Reload',
}

function getMessages() {
    try {
        const t = i18n.getFixedT(resolveInitialLanguage(), 'errors', 'boundary')
        return Object.fromEntries(Object.entries(FALLBACK_MESSAGES).map(([key, fallback]) =>
            [key, t(key, { defaultValue: fallback })]))
    } catch {
        return FALLBACK_MESSAGES
    }
}

const styles = {
    container: {
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        minHeight: '100vh', padding: '32px', fontFamily: 'sans-serif', textAlign: 'center',
        backgroundColor: '#f5f5f5', color: '#333',
    },
    icon: { fontSize: '48px', marginBottom: '16px' },
    title: { fontSize: '22px', fontWeight: 600, marginBottom: '8px' },
    body: { fontSize: '15px', color: '#555', marginBottom: '8px' },
    hint: { fontSize: '13px', color: '#888', maxWidth: '480px', marginBottom: '24px' },
    button: {
        padding: '10px 24px', fontSize: '15px', fontWeight: 500, cursor: 'pointer',
        backgroundColor: '#1976d2', color: '#fff', border: 'none', borderRadius: '6px',
    },
}

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error('[ErrorBoundary]', error, info?.componentStack)
    }

    render() {
        if (!this.state.hasError) return this.props.children

        const m = getMessages()
        return <div style={styles.container}>
            <div style={styles.icon}>⚠️</div>
            <div style={styles.title}>{m.title}</div>
            <div style={styles.body}>{m.body}</div>
            <div style={styles.hint}>{m.hint}</div>
            <button style={styles.button} onClick={() => window.location.reload()}>
                {m.reload}
            </button>
        </div>
    }
}
